import { render, staticRenderFns } from "./paper-type-picker.vue?vue&type=template&id=bc386238&scoped=true&"
import script from "./paper-type-picker.vue?vue&type=script&lang=js&"
export * from "./paper-type-picker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc386238",
  null
  
)

export default component.exports